module.exports = __webpack_public_path__ + "img/intro4.89e34046.png";